import { SeniorToolExtension } from '@blocksuite/affine-widget-edgeless-toolbar';
import { html } from 'lit';

export const mermaidSeniorTool = SeniorToolExtension(
  'mermaid',
  ({ block, toolbarContainer }) => ({
    name: 'Mermaid',
    content: html`<edgeless-mermaid-tool-button
      .edgeless=${block}
      .toolbarContainer=${toolbarContainer}
    ></edgeless-mermaid-tool-button>`,
  })
);
